import { CrownIcon, ShareIcon } from '../../../assets/icons';
import Card from '../../../components/Card';
import useModalState from '../../../context/modal/useModalState';
import { formatUSD } from '../../../helpers';
import {
    LeaderboardDto,
    SortDirection,
} from '../../../context/leaderboard/leaderboardTypes';
// import useUserRankings from '../../../hooks/analytics/useUserRankings';
import useMockUserRankings from '../../../hooks/analytics/useMockUserRankings';
import { ShareModalType } from '../../../modals/Share/ShareModal';
import UserReferral from '../../../components/UserReferral';

type LeaderboardVolumeRowProps = {
    data: LeaderboardDto & { rank: number };
    isUserRanking?: boolean;
    style?: React.CSSProperties;
    dataPerRow: number;
};

const LeaderboardVolumeRow: React.FC<LeaderboardVolumeRowProps> = ({
    data,
    isUserRanking = false,
    style,
    dataPerRow,
}) => {
    const { openModal, setModalData } = useModalState();
    // const { userData } = useUserRankings({
    //     direction: SortDirection.DESC,
    //     sortKey: 'realizedPnL',
    // });
    const { userData } = useMockUserRankings({
        direction: SortDirection.DESC,
        sortKey: 'realizedPnL',
    });

    const { rank, userId, totalMargin, totalVolume, wins, losses } = data;

    const handleCardClick = () => {
        openModal('sharePnlRankingModal');
        setModalData((prev) => ({
            ...prev,
            data: {
                position: userData,
                type: ShareModalType.PnL,
            },
        }));
    };

    return (
        <Card
            onClick={isUserRanking ? handleCardClick : undefined}
            className='leaderboard-volume__row row'
            style={style}
        >
            <div className={`leaderboard__rank rank-${rank + 1}`}>
                {rank + 1} {rank < 3 ? <CrownIcon /> : null}
            </div>
            <UserReferral className='leaderboard__user' userAddress={userId} />
            <div className='leaderboard__trades-opened'>
                <span className='column-label'>Wins</span>
                {wins}
            </div>
            <div className='leaderboard__trades-settled'>
                <span className='column-label'>Losses</span>
                {losses}
            </div>
            <div className='leaderboard__collateral'>
                <span className='column-label'>Collateral</span>
                {formatUSD(totalMargin?.toString() || 0, { minDecimals: 2 })}
            </div>
            <div className='leaderboard__volume'>
                <span className='column-label'>Volume</span>
                <div>
                    {formatUSD(totalVolume?.toString() || 0, { minDecimals: 2 })}
                    {isUserRanking && <ShareIcon />}
                </div>
            </div>
        </Card>
    );
};

export default LeaderboardVolumeRow;
